import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

const register = () => {
  window.open('/register');
};

const AnonOfferListItems = ({
  offer,
  toggleDataRoom,
  hasJoinedWorkspace,
  activeTab,
  handleRegistration,
  disableField,
}) => (
  <div className='white-nav w-clearfix' id='offerdetail'>
    <div className='link-container'>
      <React.Fragment>
        <button
          className={`transparent-link w-inline-block${
            activeTab === 0 ? ' active-tab' : ''
          }`}
          disabled={disableField}
          onClick={() => register()}
        >
          Overview
        </button>

        <button
          className={`transparent-link w-inline-block${
            activeTab === 1 ? ' active-tab' : ''
          }`}
          disabled={disableField}
          onClick={() => register()}
        >
          Investment Details
        </button>
      </React.Fragment>
    </div>
    <div className='link-container-right w-clearfix'>
      {toggleDataRoom && (
        <button
          style={{ width: 'inherit' }}
          className='btn-small-outline w-button'
          onClick={() => register()}
        >
          {hasJoinedWorkspace ? ' View Data Room' : 'Join Data Room'}
        </button>
      )}
      {!disableField && (
        <React.Fragment>
          <Link
            style={{ textDecoration: 'none', width: 'inherit' }}
            className='btn-small-outline w-button'
            to={`/register`}
          >
            Request Information
          </Link>
          <Link
            style={{ textDecoration: 'none', width: 'inherit' }}
            className='button small w-button '
            to={`/register`}
          >
            {offer.listingType === 'ASSET_SALES'
              ? 'Make Offer'
              : 'Start Investment'}
          </Link>
        </React.Fragment>
      )}

      {(offer.republicProcessType ||
        offer.wefunderProcessType ||
        offer.realexProcessType) && (
        <button
          style={{ textDecoration: 'none', width: 'inherit' }}
          className='button small w-button '
          onClick={() => handleRegistration()}
        >
          {offer.listingType === 'ASSET_SALES'
            ? 'Make Offer'
            : 'Start Investment'}
        </button>
      )}
    </div>
  </div>
);

AnonOfferListItems.propTypes = {
  offer: PropTypes.object.isRequired,
  toggleDataRoom: PropTypes.bool,
  hasJoinedWorkspace: PropTypes.bool.isRequired,
  activeTab: PropTypes.number.isRequired,
  disableField: PropTypes.bool.isRequired,
  handleRegistration: PropTypes.func,
};

AnonOfferListItems.defaultProps = {
  toggleDataRoom: false,
  hasJoinedWorkspace: false,
  activeTab: 0,
  disableField: false,
};

export default AnonOfferListItems;



// WEBPACK FOOTER //
// ./src/components/OfferOverview/AnonOfferListItems.js